import React from 'react'

import { Cta } from '../../Cta'

const Button = ({ ...rest }) => <Cta className="form-cta" {...rest} />

export default Button
